/** Tag types the block gives a meaning to: the name and the shipping data of a sectional's element. */
export enum ExtraProductInformationTagType {
  ProductName = "product_name",
  ShippingDimensions = "shipping_dimensions",
  ShippingWeight = "shipping_weight",
}

/** A single row of the extra product information block: a tag type of the product and its value. */
export class ExtraProductInformationItem {
  constructor(
    public slug: string,
    public name: string,
    public value: string,
  ) {}
}

/** One element of a sectional with its shipping data; `id` matches the `element_id` of the configuration. */
export class ExtraProductInformationElement {
  constructor(
    public id: string,
    public name: string,
    public dimensions: string,
    public weight: string,
  ) {}
}

/** The rows the backend tagged the product with and every element a sectional can be built from. */
export class ExtraProductInformation {
  constructor(
    public items: ExtraProductInformationItem[] = [],
    public elements: ExtraProductInformationElement[] = [],
  ) {}
}
